export default "__VITE_ASSET__d2d298eb__"